import styled from "styled-components"

interface BannerProps {
  color: string
  background: string
}

export const Container = styled.div`
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const Banner = styled.div<BannerProps>`
  width: 100vw;
  height: var(--banner-height, 48px);
  padding: 0 5%;
  color: ${(props) => props.color};
  background: ${(props) => props.background};
  display: flex;
  box-sizing: border-box;
  font-size: 14px;
  align-items: center;
`

export const BannerIconContainer = styled.div`
  margin-right: 15px;
`

export const BannerContent = styled.div`
  display: flex;
`
